<template>
  <div id="beststart-view">
    <section class="bg-light ftco-section">
      <div class="conatiner"></div>
    </section>
    <section class="bg-light ftco-section1">
      <div class="container">
      
        <div class="row">
          <div class="col-md-12">
            <h3 class="sub-h2 text-center">Best Start</h3>
            <h1 class="mb-4 display-4 text-center">Successful Breastfeeding</h1>
          </div>
          <div class="col-md-12 text-center">
          </div>
          <div class="col-md-6"></div>
          <div class="col-md-12">
            <p class="resources-text mb-3">
              Breastfeeding is the gold standard in infant feeding. Breastmilk provides
              immune support with amazing antibodies to give your baby everything they
              need and the best start for a healthy life. The American Academy of
              Pediatrics (<a href="http://aap.org" target="_blank">aap.org</a>) recommends
              exclusive breastfeeding for 6 months, introducing foods after 6 months of
              life and continuing breastfeeding for a year and beyond. The World Health
              Organization (<a href="http://who.int" target="_blank">who.int</a>)
              recommends breastfeeding for two years and beyond.
            </p>
            <h1 class="text-black display-4 text-center my-4">
              Getting Off To The Best <br />Start Breastfeeding
            </h1>

            <p class="py-3 text-center text10 mb-3">
              The Global Health Media Project share Breastfeeding education with moms and
              babies all over the world.
            </p>
           
            <div class="bg-grey p-5">
              <p class="text-center"> For information including videos on latching, breastfeeding, positions, hand
              expression and much more please go to</p>
             
              <div class="text-center">
                <a
                  href="https://globalhealthmedia.org/portfolio-items/breastfeeding-attachment/"
                  target="_blank"
                  >https://globalhealthmedia.org/portfolio-items/breastfeeding-attachment/</a
                >
                <br />
                The Global Health Media Project share Breastfeeding education with moms
                and babies all over the world.
              </div>
            </div>
            <p class="resources-text pt-3">
              The information below will help you and your baby get off to a great start
            </p>
            <ul>
              <li class="resources-text">
                Place your baby skin to skin in the early days of life, this helps to
                initiate feeding. Skin to skin following birth has been found to be very
                beneficial for baby and to help initiate the first feeding.
              </li>
              <li class="resources-text">
                Watch your baby for early feeding cues…lips smacking, licking his/her
                lips, rooting. Crying can be a late feeding cue. In the early days and
                hours many times an awake baby is a hungry baby.
              </li>
              <li class="resources-text">
                Feed baby on demand; your goal is at least 8-12 feedings in 24 hours. Baby
                may be very sleepy and may not have any interest in eating in the first 24
                hours. If baby is too sleepy to eat, place baby skin to skin and offer the
                breast every couple of hours. You can also try to hand express some
                colostrum into baby’s mouth to peak interest.
              </li>
              <li class="resources-text">
                After the long sleepy stage which can happen in the first 24 hours of life
                baby may wake frequently to eat and eat continuously for several hours.
                This is known as cluster feedings and is normal newborn behavior,
                especially in the baby’s second night of life. The cluster feedings help
                transition your milk from colostrum to mature milk. Cluster feedings also
                happen when baby is going through a growth spurt.
              </li>
              <li class="resources-text">
                In the early days be sure to offer both breasts to baby as much as
                possible. Once your mature milk is in around days 2-5, your baby may take
                only one side per feeding, be sure to feed on the other side for the next
                feeding. Usually you will know baby is done with feeding as he-she will
                fall asleep or come off the breast at this time you can feel that your
                breast has emptied or softened. Feeding lengths can vary between 5-45
                minutes. If baby is still hungry after feeding on one breast, offer the
                other breast. Make sure to start the next feeding with the breast the baby
                didn’t feed on or fed the least amount of time on. Keep in mind your baby
                has a tiny tummy in the early days of life. Your milk is the perfect food
                and comes in the perfect amount for your baby..
                <a
                  href="/pdf/Baby_s_Tummy_Size_Mother_s_Milk_Supply.pdf"
                  download="Baby_s_Tummy_Size_Mother_s_Milk_Supply.pdf"
                  rel="nofollow"
                  ></a
                >
              </li>
              <li class="resources-text">
                If your baby isn’t latching or nursing well following birth a breast pump
                can help you establish and maintain your milk supply while working on
                breastfeeding. Colostrum and mature milk can be hand expressed or pumped
                and given to your baby by syringe, cup, spoon or bottle.
              </li>
            </ul>
            <div class="bg-grey p-5">
              <strong><p class="text-center">
                For information on establishing milk supply while separated from your baby
                or while your baby is having difficulties breastfeeding see information on
                maximizing milk production. Thank you to Jane Morton at Standford Medicine
                for sharing information on maximizing milk production. </p></strong><br />
              <div class="text-center">
                <a
                  href="https://med.stanford.edu/newborns/professional-education/breastfeeding/maximizing-milk-production.html"
                  target="blank_"
                  >https://med.stanford.edu/newborns/professional-education/breastfeeding/maximizing-milk-production.html</a
                >
                <br />
                Thank you to Jane Morton at Standford Medicine for sharing information on
                maximizing milk production.
              </div>
            </div>
            <ul>
              <li class="resources-text"> A list of Lactation Consultants in the Hawaiian Islands can be found at
                <a href="https://bfhawaii.org/" target="_blank">https://bfhawaii.org/</a>
              </li>
              <li class="resources-text">
                Choosing to give birth at a facility that protects, promotes and supports
                breastfeeding is helpful in getting off to a great start. Please see the
                10 steps to Successful Breastfeeding from Baby Friendly USA below.
                Choosing a pediatrician who supports breastfeeding will help you in your
                early days.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section>
     
      <div class="container-fluid">
        <img src="@/assets/site/images/bg-best.png" class="img-fluid" alt="" />
      </div>
    </section>
    <section class="bg-light ftco-section1">
      <div class="container py-5">
        <p class="resources-text">
          The Ten Steps to Successful Breastfeeding form the basis of the Baby-Friendly
          Hospital Initiative, a worldwide breastfeeding quality improvement project
          created by the World Health Organization (WHO) and the United Nations Children’s
          Fund (UNICEF). Baby-Friendly hospitals and birth centers also uphold the
          International Code of Marketing of Breast Milk Substitutes by offering parents
          support, education, and educational materials that promote the use of human milk
          rather than other infant food or drinks, and by refusing to accept or distribute
          free or subsidized supplies of breastmilk substitutes, nipples, and other
          feeding devices.
        </p>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="resources-text pb-3">
              This information is to be used at the discretion of the individual and is
              not a substitute for medical advice. Please contact your lactation
              consultant or Primary care provider for medical advice.
            </div>
          </div>
        </div>
      </div>
    
      <div class="row text-center">
        <div class="col-md-12">
          <h3 class="text-center mt-5 text-dark font-italic">MORE ON</h3>
        </div>
      </div>
      <lactationres-icons></lactationres-icons>
    </section>

  </div>
  
</template>

<script>
import LactationresIcons from "@/views/site/LactationresIcons";
export default {
  name: "BeststartView",
  components: {
    LactationresIcons,
  },
};
</script>
